export default __webpack_public_path__ + "static/media/staggeringblow4.f3baabd4.png";